import { useField } from "formik";
import React from "react";
import {
  OrganisationMembersSelect,
  OrganisationMembersSelectProps,
} from "../OrganisationMembersSelect.js";

interface Props extends Omit<
  OrganisationMembersSelectProps,
  "value" | "onChange"
> {
  name: string;
  value?: string[];
  onChange?: (value: string[]) => void;
  onChanged?: () => void | Promise<void>;
}

export const OrganisationMembersField = ({
  name,
  value: valueProp,
  onChange: onChangeProp,
  onChanged,
  ...props
}: Props) => {
  const [{ value }, { touched, error }, { setValue }] =
    useField<string[]>(name);

  return (
    <OrganisationMembersSelect
      value={valueProp !== undefined ? valueProp : value}
      onChange={
        onChangeProp ??
        (async value => {
          await setValue(value);
          onChanged?.();
        })
      }
      {...props}
      error={props.error ?? (touched ? error : undefined)}
    />
  );
};
